<template>
  <div class="dados-fisicos-details">
    <page-header :title="title" />
    <page-section>
      <v-row no-gutters>
        <v-col class="mb-4">
          <field-section
            :label="$t('Castrado')"
            :value="pet.castrado"
            :is-restrict="$store.getters['pet/isRestrict']('castrado')"
          >
            <template #value>
              {{ convert(pet.castrado) }}
            </template>
          </field-section>
        </v-col>
        <v-col class="mb-4">
          <field-section
            :label="$t('Pedigree')"
            :value="pet.pedigree"
            :is-restrict="$store.getters['pet/isRestrict']('pedigree')"
          >
            <template #value>
              {{ convert(pet.pedigree) }}
            </template>
          </field-section>
        </v-col>
      </v-row>
    </page-section>
    <Form :title="title" :data="pet" />
  </div>
</template>

<script>
import i18next from "i18next";
import PageHeader from "@/components/headers/page-header";
import PageSection from "@/components/sections/page-section";
import FieldSection from "@/components/sections/field-section";
import Form from "./form";
export default {
  metaInfo: {
    titleTemplate: (i18next.t("Dados_Fisicos") || "") + " | %s",
  },
  components: { FieldSection, PageSection, PageHeader, Form },
  data: () => ({
    title: i18next.t("Dados_Fisicos"),
  }),
  computed: {
    pet() {
      return this.$store.state.pet.data || {};
    },
    convert() {
      return (value) => (value ? this.$t("Sim") : this.$t("Nao"));
    },
  },
};
</script>

<style scoped></style>
